import React from 'react';
import PropTypes from 'prop-types';
import EnhancedRaisedButton from './EnhancedRaisedButton';
import translate from 'components/hoc/translate';

const PrimaryButton = (props) => {
    const {
        disabled,
        label,
        loading,
        onClick,
        primary,
        translate,
    } = props;

    return (
        <EnhancedRaisedButton
            onClick={ onClick }
            disabled={ disabled }
            label={ label || translate('actions.select') }
            loading={ loading }
            primary={ primary }
            type='button'
        />
    );
};

PrimaryButton.defaultProps = {
    disabled: false,
    loading: false,
    primary: true,
};

PrimaryButton.propTypes = {
    disabled: PropTypes.bool,
    label: PropTypes.string,
    loading: PropTypes.bool,
    onClick: PropTypes.func,
    primary: PropTypes.bool,
    translate: PropTypes.func.isRequired,
};

export default translate(PrimaryButton);



// WEBPACK FOOTER //
// ./src/components/button/PrimaryButton.js